import LoginError from "components/layout/StatusPage/LoginError"
import { Route } from "react-router-dom"
import CallbackPage from "./CallbackPage"
import SilentCallbackPage from "./SilentCallbackPage"
import SsoCallback from "./SsoCallback"

export const AuthenticationRoutes = () => {
  return <>
    <Route
      path="/authentication/callback"
      element={<CallbackPage />}
    />

    {/* Route de callback silencieux pour le renouvellement des tokens */}
    <Route
      path="/authentication/silent-callback"
      element={<SilentCallbackPage />}
    />

    <Route path="/sso-callback" element={<SsoCallback />} />
    <Route path="/login-error" element={<LoginError />} />

  </>
}
